import { LOGOUT } from 'Reducers/auth/types';
import log from 'Utilities/log';
import { clearCookie, clearSession, getCookie, getObject, getSessionObject, removeObject, setCookie, setSessionObject } from 'Utilities/storage';
import mediator from './mediator';
import { store } from './store';
export const persistAuthSession = session => {
  try {
    setSessionObject('authSession', session);
    setCookie('authSession', session, session.expires);

    // remove old session from localStorage
    const storedSession = getObject('authSession');
    if (storedSession) {
      removeObject('authSession');
    }
  } catch (err) {
    log.error(err);
  }
};
export const getAuthSession = () => {
  try {
    // Try to get our token from session storage first or fallback to cookies
    let authSession = getSessionObject('authSession');
    if (!authSession) {
      authSession = getCookie('authSession');
    }
    return authSession;
  } catch (e) {
    return null;
  }
};
export const logout = () => {
  clearSession();
  clearCookie('authSession');
  store.dispatch({
    type: LOGOUT
  });
  mediator.publish('router:navigate', '/login');
};